import * as React from 'react';
import * as _ from 'lodash';
import Pager from './../../PageLayout/Pager';
import classNames from 'classnames';
import * as helpers from './../../../utilities/helpers';
import { bkgImage } from './../../../utilities/helpers';
import * as misc from './../../../misc';
export default function () {
    function onClick1(stones, s, sIndex) {
        this.props.selectStone(s, !s.checked);
    }
    function repeatS2(stones, s, sIndex) {
        return React.createElement('li', {
            'className': 'assign-list__item',
            'key': s.id
        }, React.createElement('div', { 'className': 'assign-card' }, React.createElement('div', {
            'className': 'assign-card__checkbox',
            'onClick': onClick1.bind(this, stones, s, sIndex)
        }, React.createElement('div', { 'className': 'ui-svg-checkbox' }, React.createElement('div', { 'className': 'ui-svg-checkbox__icon' }, React.createElement('svg', {
            'className': 'ui-svg-checkbox__icon-circle',
            'height': '30',
            'width': '30'
        }, React.createElement('circle', {
            'cx': '15',
            'cy': '15',
            'r': '12.5',
            'stroke': '#979797',
            'strokeWidth': '3',
            'fill': '#ffffff'
        })), s.checked ? React.createElement('div', {
            'className': 'ui-svg-checkbox__icon-checked-icon',
            'key': '1022'
        }) : null), React.createElement('div', { 'className': 'ui-svg-checkbox__text' }))), React.createElement('div', {
            'className': 'assign-card__image',
            'style': { 'backgroundImage': bkgImage(s.imageUrl || s.imageFullUrl) }
        }), React.createElement('div', { 'className': 'assign-card__title' }, s.name)));
    }
    function scopeStones3() {
        var stones = this.props.stones.toJS();
        return React.createElement('div', { 'className': 'app-content-wrapper2' }, React.createElement('div', { 'className': 'assign-container' }, React.createElement.apply(this, [
            'ul',
            { 'className': 'assign-list' },
            _.map(stones, repeatS2.bind(this, stones))
        ]), this.props.totalPages > 1 ? React.createElement(Pager, {
            'totalPages': this.props.totalPages,
            'page': this.props.page,
            'pageClick': this.handlePageClick,
            'key': '1436'
        }) : null));
    }
    return scopeStones3.apply(this, []);
}